<template>
	<div class="container p-0" style="height: 100%">
		<div v-if="page_loading == 1" class="text-center mt-5">
			<div class="text-center my-2 p-2 gold">
				<i class="fas fa-spinner fa-spin fa-2x"></i>
				<p>Loading...</p>
			</div>
		</div>
		<div v-else>
			<!-- <div class="layoutJSON">
				Displayed as <code>[i, x, y, w, h]</code>:
				<b
					>Screen Size: <span v-text="window.width"></span>:<span v-text="window.size"></span
				></b>
				<div class="columns">
					<div v-for="item in responsive_layouts[window.size]" :key="'vars_' + item.i">
						<b>{{ item.i }}</b> : [{{ item.x }}, {{ item.y }}, {{ item.w }}, {{ item.h }}]
					</div>
				</div>
			</div>
			<hr />
			<div class="row">
				<div class="col">
					<input type="checkbox" v-model="draggable" /> Draggable
					<input type="checkbox" v-model="resizable" /> Resizable
					<input type="checkbox" v-model="responsive" /> Responsive
				</div>
				<div class="col text-right"></div>
			</div> -->

			<div
				v-if="user_has_saved_layouts == 1 && show_resize_message"
				class="sticky-top float-right"
			>
				<b-card
					no-body
					border-variant="danger"
					style="width: 250px"
					class="text-center small p-1"
				>
					<small>
						Layout group changed to<br />
						<b v-html="window_groups[window.size]"></b>
					</small>
					<div class="text-center">
						<b-button size="sm" href="#" variant="success" @click="userCardsGet">
							<small><i class="fas fa-check"></i> Load Saved</small>
						</b-button>

						<b-button size="sm" href="#" variant="outline-secondary" @click="layout_toggle">
							<small><i class="fas fa-pencil-alt"></i> Edit</small>
						</b-button>
						<b-button
							size="sm"
							href="#"
							variant="outline-danger"
							@click="show_resize_message = 0"
						>
							<small><i class="fas fa-times"></i> Cancel</small>
						</b-button>
					</div>
				</b-card>
			</div>

			<div v-if="user_has_saved_layouts == 0">
				<b-alert show variant="primary">
					<h5>Save your layouts</h5>
					<p>
						You can save the layout of your Dashboard for each type of device you are viewing
						on,<br />eg: Mobile, Tablet, Laptop and Desktop.<br />
						To enter the save desktop layout, click the <i class="fas fa-ellipsis-v"></i> icon
						on any of the Dashboard cards and then click 'Edit Dashboard Layout' to enter
						editor mode.
					</p>
				</b-alert>
			</div>

			<div v-if="draggable === true" class="sticky-top">
				<b-alert show variant="warning">
					<div class="text-center">
						<small class="pl-1">
							<b>Resize: </b>Use the bottom right corner of a card - <b>Move: </b>Click and
							drag anywhere on a card
						</small>

						<b-button v-if="update_button" size="sm" variant="success" @click="saveLayout()">
							<i class="fas fa-check"></i> Save
						</b-button>
						<b-button size="sm" variant="danger" @click="cancelLayout"
							><i class="fas fa-times"></i> Cancel
						</b-button>

						<h6 class="p-2" v-if="layout_saving">
							<i class="fas fa-spinner fa-spin fa-2x"></i>
							Saving...
						</h6>
					</div>
				</b-alert>
			</div>

			<div style="width: 100%; margin-top: 10px; height: 100%">
				<grid-layout
					v-if="responsive_layouts[window.size].length > 0"
					:layout.sync="responsive_layouts[window.size]"
					:col-num="12"
					:row-height="30"
					:is-draggable="draggable"
					:is-resizable="resizable"
					:responsive="responsive"
					:responsive-layouts="responsive_layouts"
					:vertical-compact="true"
					:use-css-transforms="true"
					:breakpoints="breakpoints"
					:auto-size="true"
					@layout-ready="layoutReadyEvent"
				>
					<grid-item
						v-for="item in responsive_layouts[window.size]"
						:key="'C_' + window.size + '_' + item.i"
						:ref="'G_' + window.size + '_' + item.i"
						:static="item.static"
						:x="item.x"
						:y="item.y"
						:w="item.w"
						:h="item.h"
						:i="item.i"
						:min-w="parseInt(2)"
						:min-h="parseInt(6)"
						@resize="layoutUpdatedEvent"
						@move="layoutUpdatedEvent"
						class="card"
						:class="{ 'border-danger': draggable === true }"
					>
						<div class="card-header p-1">
							<div class="row small">
								<div class="col-10 text-left">
									<span
										v-if="cards[item.i].meta_fields.tooltip"
										class="float-left pl-2 pt-2 pr-1 gold"
										v-b-tooltip.hover
										:title="cards[item.i].meta_fields.tooltip"
									>
										<i class="far fa-question-circle"></i>
									</span>
									<div v-text="cards[item.i].title" class="pl-2 pt-2"></div>
								</div>
								<div class="col-2 text-right">
									<b-dropdown
										class="gold"
										right
										variant="outlined-primary"
										size="sm"
										no-caret
									>
										<template #button-content>
											<i class="fas fa-ellipsis-v"></i>
										</template>

										<b-dropdown-item
											><b>Menu Actions: </b>
											<small v-html="window_groups[window.size]"></small>
										</b-dropdown-item>

										<b-dropdown-divider></b-dropdown-divider>

										<b-dropdown-item>
											<b>Layout Options</b>
										</b-dropdown-item>

										<b-dropdown-item v-if="user_has_saved_layouts === 1" href="#">
											<small @click="userCardsGet"
												><i class="fas fa-sync"></i> Refresh Layout
											</small>
										</b-dropdown-item>
										<b-dropdown-item href="#">
											<small v-if="draggable === true" @click="saveLayout()">
												<i class="far fa-save"></i> Save this layout
											</small>
											<small v-else @click="layout_toggle">
												<i class="fas fa-expand-arrows-alt"></i> Edit Dashboard Layout
											</small>
										</b-dropdown-item>

										<b-dropdown-item>
											<span class="small text-danger" @click="removeItem(item.i)">
												<i class="fas fa-trash-alt"></i> Remove Card
											</span>
										</b-dropdown-item>
									</b-dropdown>
								</div>
							</div>
						</div>

						<div class="card-body card_container">
							<div v-if="cards[item.i].component === 'CountdownTimer'" class="text-center">
								<countdown-timer />
							</div>

							<div
								v-else-if="cards[item.i].component === 'ChartLine'"
								class="text-center silver"
							>
								<div
									v-if="cards[item.i].data !== null"
									class="col-12 p-2 text-center silver"
								>
									<chart-line :chartdata="cards[item.i].data.chartdata" />
								</div>
								<div v-else class="pt-2">
									<p><i class="fas fa-chart-pie fa-2x"></i></p>
									<p><small>Nothing to show for the last 7 days...</small></p>
								</div>
							</div>
							<div v-else-if="cards[item.i].component === 'DreamsLog'" class="text-center">
								<dreams-log
									:userid="parseInt(profile.id)"
									:readonly="cards[item.i].readonly"
								/>
							</div>
							<div v-else-if="cards[item.i].component === 'FeelingsLog'" class="text-center">
								<feelings-log
									:userid="parseInt(profile.id)"
									:readonly="cards[item.i].readonly"
								/>
							</div>
							<div v-else-if="cards[item.i].component === 'HabitsCard'" class="">
								<habits-card />
							</div>
							<div
								v-else-if="cards[item.i].component === 'SharedUserData'"
								class="text-center"
							>
								<shared-user-data />
							</div>

							<div v-else>
								<p class="text-center p-2 silver">
									<i class="fas fa-atom fa-3x"></i><br />
									<small>Nothing to see here...</small>
								</p>
							</div>
						</div>

						<div class="card-footer p-0">
							<div class="row">
								<div class="col">
									<div v-if="cards[item.i].meta_fields.link" class="pl-2">
										<a
											:href="cards[item.i].meta_fields.link"
											class="btn-link small gold"
											v-text="cards[item.i].meta_fields.link_text"
										></a>
									</div>
								</div>
								<div class="col text-right"></div>
							</div>
						</div>
					</grid-item>
				</grid-layout>
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios';
import VueGridLayout from 'vue-grid-layout';
import ChartLine from '../components/ChartLine.vue';
import CountdownTimer from '../components/CountdownTimer.vue';
import DreamsLog from '../components/DreamsLog.vue';
import FeelingsLog from '../components/FeelingsLog.vue';
import HabitsCard from '../components/HabitsCard.vue';
import SharedUserData from '../components/SharedUserData.vue';

export default {
	name: 'DashboardUser',
	components: {
		ChartLine,
		CountdownTimer,
		DreamsLog,
		FeelingsLog,
		GridLayout: VueGridLayout.GridLayout,
		GridItem: VueGridLayout.GridItem,
		HabitsCard,
		SharedUserData,
	},
	props: {
		profile: {
			type: Object,
			default: null,
		},
	},
	data() {
		return {
			breakpoints: {
				xxs: 0,
				xs: 767,
				sm: 996,
				md: 1200,
				lg: 1400,
			},
			cards: null,
			window: {
				width: 0,
				height: 0,
				size: null,
				last_size: null,
			},
			window_groups: {
				xs: '<i class="fas fa-mobile-alt"></i> Mobile',
				sm: '<i class="fas fa-tablet-alt"></i> Small Tablet',
				md: '<i class="fas fa-laptop"></i> Tablet/Laptop',
				lg: '<i class="fas fa-desktop"></i> Desktop',
			},
			/*layout_active: [],*/
			layout_saving: false,
			layout_msg: null,
			page_loading: 1,
			draggable: false,
			resizable: false,
			responsive: true,
			responsive_layouts: {},

			show_resize_message: 0,

			index: 0,
			update_button: false,
			user_has_saved_layouts: 0,
		};
	},
	computed: {
		/*profile() {
			return this.$store.getters.profileGet;
		},*/
	},
	methods: {
		handleResize() {
			this.window.width = window.innerWidth;
			this.window.height = window.innerHeight;
			const obj = Object.entries(this.breakpoints);
			for (const [k, v] of obj) {
				this.window.size = k;
				if (this.window.width <= v) {
					break;
				}
			}
		},
		layout_toggle() {
			if (this.draggable === true) {
				this.draggable = false;
				this.resizable = false;
			} else {
				this.draggable = true;
				this.resizable = true;
				this.show_resize_message = 0;
			}
		},
		layoutUpdatedEvent() {
			console.log('layoutUpdatedEvent');
			this.update_button = true;
		},
		layoutReadyEvent: function (newLayout) {
			console.log('layoutReadyEvent', newLayout);
			/*const obj = Object.values(newLayout);
			for (const item of obj) {
				console.log('Ready layout: ', item);
				console.log(this.$refs['G_' + this.window.size + '_' + item.i]);
				this.$refs['G_' + this.window.size + '_' + item.i].autoSize();
			}*/
		},
		containerResizedEvent: function (i, newH, newW, newHPx, newWPx) {
			const msg =
				'CONTAINER RESIZED i=' +
				i +
				', H=' +
				newH +
				', W=' +
				newW +
				', H(px)=' +
				newHPx +
				', W(px)=' +
				newWPx;
			console.log(msg);
		},

		addItem: function () {
			/* Add a new item. It must have a unique key! */
			this.layout.push({
				x: (this.layout.length * 2) % (this.colNum || 12),
				y: this.layout.length + (this.colNum || 12), // puts it at the bottom
				w: 2,
				h: 2,
				i: this.index,
			});
			/* Increment the counter to ensure key is always unique. */
			this.index++;
		},
		removeItem(val) {
			const index = this.responsive_layouts[this.window.size].map((item) => item.i).indexOf(val);
			this.responsive_layouts[this.window.size].splice(index, 1);
			this.saveLayout();
		},

		cancelLayout() {
			this.layout_toggle();
			this.userCardsGet();
		},
		saveLayout() {
			console.log('saveLayout');
			let _this = this;
			_this.update_button = false;
			_this.layout_saving = true;
			_this.layout_msg = 'saving';

			let params = new URLSearchParams();
			params.append('user_id', _this.profile.id);

			const obj = Object.entries(_this.responsive_layouts);
			for (const [size, v] of obj) {
				if (size !== 'undefined') {
					const size_set = Object.entries(v);
					for (const [k2, v2] of size_set) {
						const item = Object.entries(v2);
						for (const [k3, v3] of item) {
							params.append('layout[' + size + '][' + k2 + '][' + k3 + ']', v3);
						}
					}
				}
			}

			axios({
				method: 'post',
				url:
					_this.$store.state.api_url +
					'cardsUserDashboardLayoutSave?token=' +
					_this.$store.state.session_id,
				data: params,
			})
				.then(function (response) {
					_this.layout_msg = response.data.message;
					if (response.data.status == 1) {
						_this.layout_toggle();
						_this.layout_saving = false;
					}
					_this.responsive_layouts = response.data.responsive_layouts;
					_this.user_has_saved_layouts = response.data.user_has_saved_layouts;
				})
				.catch(function (e) {
					console.log('Error: saveLayout: ' + e);
				});
		},
		userCardsGet() {
			console.log('userCardsGet');
			let _this = this;
			_this.page_loading = 1;
			_this.responsive_layouts = {};
			let params = new URLSearchParams();
			params.append('user_id', _this.profile.id);

			axios({
				method: 'post',
				url:
					_this.$store.state.api_url +
					'cardsUserDashboardGet?token=' +
					_this.$store.state.session_id,
				data: params,
			})
				.then(function (response) {
					_this.cards = response.data.cards;
					_this.responsive_layouts = response.data.responsive_layouts;
					_this.user_has_saved_layouts = response.data.user_has_saved_layouts;
					_this.page_loading = 0;
					_this.show_resize_message = 0;
				})
				.catch(function (e) {
					console.log('Error: userCardsGet: ' + e);
				});
		},
	},
	mounted() {
		if (this.profile.id) {
			this.userCardsGet();
		}
	},
	created() {
		window.addEventListener('resize', this.handleResize);
		this.handleResize();
	},
	destroyed() {
		window.removeEventListener('resize', this.handleResize);
	},
	watch: {
		profile(val) {
			if (val.id) {
				this.userCardsGet();
			}
		},
		window: {
			deep: true,
			handler(val) {
				if (val.last_size != val.size) {
					this.window.last_size = val.size;
					this.show_resize_message = 1;
				}
			},
		},
	},
};
</script>

<style scoped>
.card_container {
	padding: 8px;
	overflow: auto;
}
.vue-grid-layout {
	background: #fff;
}

.vue-grid-item:not(.vue-grid-placeholder) {
	background: #fff;
	border: 1px solid #ccc;
}

.vue-grid-item .resizing {
	opacity: 0.9;
}

.vue-grid-item .static {
	background: #cce;
}

.vue-grid-item .text {
	font-size: 24px;
	text-align: center;
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	margin: auto;
	height: 100%;
	width: 100%;
}

.vue-grid-item .no-drag {
	height: 100%;
	width: 100%;
}

.vue-grid-item .minMax {
	font-size: 12px;
}

.vue-grid-item .add {
	cursor: pointer;
}

.vue-draggable-handle {
	position: absolute;
	width: 20px;
	height: 20px;
	top: 0;
	left: 0;
	background: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='10' height='10'><circle cx='5' cy='5' r='5' fill='#999999'/></svg>")
		no-repeat;
	background-position: bottom right;
	padding: 0 8px 8px 0;
	background-repeat: no-repeat;
	background-origin: content-box;
	box-sizing: border-box;
	cursor: pointer;
}

.layoutJSON {
	background: #ddd;
	border: 1px solid black;
	margin-top: 10px;
	padding: 10px;
}

.columns {
	-moz-columns: 120px;
	-webkit-columns: 120px;
	columns: 120px;
}
</style>
